@use 'shared/styles/generated/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: $space-medium-xs;
  min-height: 100%;
  padding-top: $space-medium-xs;
}

.starsBlock {
  position: relative;
  width: 100%;
}

.star {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.starFlat {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: $radius-round;
  background: $color-surface-alt;
  color: $color-text-secondary;
}

.thread {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.mascot {
  align-self: center;
  margin-top: calc(-1 * #{$space-large-xs});
}

// Слот под вопрос о поле — тот же приём, что в A1 (NameStepWidget): место занято всегда,
// иначе появление чипов толкает поле имени вверх и экран прыгает прямо во время ввода.
.genderSlot {
  opacity: 0;
  transform: translateY(calc(-1 * #{$space-small-m}));
  pointer-events: none;
  transition:
    opacity $duration-normal $easing-out,
    transform $duration-normal $easing-out;
}

.genderSlotVisible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
